import { useUserBalances } from '@givebacks/api/ledger';
import { BalanceCard, Modal, ModalProps, Stack } from 'ui';

import { ClickableOptionsCard } from '../../../Cards';

interface AvailableBalanceModalProps extends ModalProps {
  onTransferClick: () => void;
  onDonationClick: () => void;
  modalProps: Partial<ModalProps>;
}
interface AvailableBalanceContentProps
  extends Pick<AvailableBalanceModalProps, 'onTransferClick' | 'onDonationClick'> {}

const AvailableBalanceContent = ({
  onDonationClick,
  onTransferClick,
}: AvailableBalanceContentProps) => {
  const { data: balance, isLoading } = useUserBalances();
  return (
    <Stack gap="lg">
      <BalanceCard
        isLoading={isLoading}
        available={balance?.available}
        pending={balance?.pending?.amount}
      />
      <ClickableOptionsCard>
        <ClickableOptionsCard.Row title="Make a Donation" onClick={onDonationClick} />
        <ClickableOptionsCard.Row title="Transfer Available Balance" onClick={onTransferClick} />
      </ClickableOptionsCard>
    </Stack>
  );
};

const AvailableBalanceModal = ({
  opened,
  onClose,
  modalProps,

  ...rest
}: AvailableBalanceModalProps) => {
  return (
    <Modal opened={opened} onClose={onClose} title="Available Balance" {...modalProps}>
      <AvailableBalanceContent {...rest} />
    </Modal>
  );
};

export { AvailableBalanceModal };
